import React from 'react';
import {
  Control as BulmaControl,
  Field as BulmaField,
} from 'react-bulma-components/lib/components/form';
import './style.scss';

export const Control = ({ children, ...props }) => (
  <BulmaControl {...props}>{children}</BulmaControl>
);

export const Field = ({ children, ...props }) => (
  <BulmaField {...props}>{children}</BulmaField>
);

export default Field;
